export default __webpack_public_path__ + "static/media/Image-1.f4891ec6.jpg";